import React from 'react';
import { FaFacebook, FaGithub, FaLinkedin } from 'react-icons/fa';

const socialLinks = () => {
    return (

<div className="social_Links flex text-3xl my-3">
        <a
          className="p-2 border-[2px]  border-primary  rounded-full m-2"
          rel="noreferrer"
          href="https://facebook.com/coddermoon"
          target="_blank"
        >
          <div className="social_icon">
            <FaFacebook />
          </div>
        </a>
        <a
          className="p-2 border-[2px]  border-primary rounded-full m-2"
          rel="noreferrer"
          href="https://linkedin.com/in/mahamodulhasanmoon"
          target={"_blank"}
        >
          <div className="social_icon">
            <FaLinkedin />
          </div>
        </a>
        <a
          className="p-2 border-[2px]  border-primary rounded-full m-2"
          rel="noreferrer"
          href="https://github.com/mahamodulhasanmoon"
          target={"_blank"}
        >
          <div className="social_icon">
            <FaGithub />
          </div>
        </a>
      </div>

    );
};

export default socialLinks;